/**
 * Stable id of the step `<h1>` rendered by `StepHeader` / `Header.Title`.
 * Radio groups without a CMS label should point `aria-labelledby` here so the
 * group name is the step question instead of a missing id.
 */
export const STEP_TITLE_ID = 'step-title';

type RadioGroupNameProps = { label: string } | { 'aria-labelledby': string };

/**
 * Sitecore radio groups often have an empty `label` while the question lives in
 * the step title. Prefer a visible `RadioGroup` label when CMS provides one;
 * otherwise name the group from the step heading.
 */
export const getRadioGroupNameProps = (label?: string | null): RadioGroupNameProps => {
  const trimmed = label?.trim();

  return trimmed ? { label: trimmed } : { 'aria-labelledby': STEP_TITLE_ID };
};
